import React, { useState } from 'react';
import ConfirmModal from 'shared/components/ConfirmModal';
import { deletePlace } from 'modules/Place/services/placeService';
import { useHistory } from 'react-router';
import { routes } from 'shared/constants/routes';
import { toast } from 'react-toastify';
import { useTranslations } from 'shared/translations/useTranslations';
import { Button } from '@mantine/core';

// import './styles.scss';

const DeletePlace = ({ id }) => {
  const translations = useTranslations();
  const [isOpen, setOpen] = useState();
  const [isLoading, setLoading] = useState();
  const history = useHistory();
  const onDelete = async () => {
    try {
      setLoading(true);
      setOpen(false);
      await deletePlace(id);
      setLoading(false);
      history.push(routes.places.list.path);
      toast.success(translations.places.deleteFacilitySuccess);
    } catch {
      toast.error(translations.global.somethingWentWrong);
    }
  };
  return (
    <>
      <ConfirmModal
        isOpen={isOpen}
        paragraph={
          <div>
            {translations.places.deleteFacilityDesc1} {id}.
            <br /> {translations.places.deleteFacilityDesc2}
          </div>
        }
        isLoading={isLoading}
        onClose={() => setOpen(false)}
        onConfirm={onDelete}
        title={translations.places.deleteFacility}
        confirmLabel={translations.global.delete}
        cancelLabel={translations.global.cancel}
      />
      <Button color="red" buttonType="button" onClick={() => setOpen(true)} isLoading={isLoading}>
        {translations.global.delete}
      </Button>
    </>
  );
};

export default DeletePlace;
